import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ShoppingCart, BookOpen, User2, LayoutDashboard, LogOut, Library } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const { count } = useCart();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-border/60">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center">
            <BookOpen className="h-5 w-5 text-white" />
          </div>
          <span className="font-heading font-bold text-lg tracking-tight text-slate-900">
            Notes<span className="text-primary">Bazaar</span>
          </span>
        </Link>

        <nav className="flex items-center gap-2 md:gap-3">
          <Link to="/" data-testid="nav-browse">
            <Button variant="ghost" className="text-slate-600 hover:text-primary hidden sm:inline-flex">
              Browse
            </Button>
          </Link>

          <Link to="/cart" className="relative" data-testid="nav-cart">
            <Button variant="ghost" size="icon" className="text-slate-600 hover:text-primary">
              <ShoppingCart className="h-5 w-5" />
            </Button>
            {count > 0 && (
              <span
                className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-primary text-white text-[11px] font-semibold flex items-center justify-center"
                data-testid="cart-count-badge"
              >
                {count}
              </span>
            )}
          </Link>

          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="gap-2 rounded-full" data-testid="nav-user-menu">
                  <User2 className="h-4 w-4" />
                  <span className="hidden sm:inline max-w-[100px] truncate">{user.name}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-52">
                <DropdownMenuItem onClick={() => navigate("/purchases")} data-testid="menu-purchases">
                  <Library className="h-4 w-4 mr-2" /> My Notes
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => navigate("/sell")} data-testid="menu-sell">
                  <LayoutDashboard className="h-4 w-4 mr-2" /> Seller Dashboard
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={logout} className="text-destructive" data-testid="menu-logout">
                  <LogOut className="h-4 w-4 mr-2" /> Log out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login">
                <Button variant="ghost" className="text-slate-600 hover:text-primary">
                  Log in
                </Button>
              </Link>
              <Link to="/register" data-testid="nav-register">
                <Button className="rounded-full">Get started</Button>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
